import React from "react";
import KernelVaultInput from "./KernelVaultInput";

/**
 * Simple Deposit Component
 * Uses KernelVaultInput for consistent UI across all vaults with Kernel Design System
 */
export interface DepositProps {
  // Vault info
  vaultTokenSymbol: string;
  inputTokenSymbol: string;
  inputTokenIcon?: string;
  vaultTokenIcon?: string;

  // Balances
  inputTokenBalance: number;
  vaultTokenBalance: number;

  // Converted amount (calculated by vault hook)
  convertedAmount: string;
  exchangeRateDisplay?: string;

  // State
  isConnected: boolean;
  isApproved: boolean;
  isSupportedChain?: boolean;

  // Callbacks
  onDeposit: (amount?: string) => void;
  onApprove: (amount?: string) => void;
  onAmountChange?: (amount: string) => void;
  onTokenSelect?: (token: string) => void;

  // Optional
  vaultType?: "airdrop" | "highGrowth" | "stable" | "yield" | "cryptanium";
  disclaimer?: React.ReactNode;
  checkInputConstraints?: (amount: string) => string;
  enableTokenSelection?: boolean;
}

const Deposit = ({
  vaultTokenSymbol,
  inputTokenSymbol,
  inputTokenIcon,
  vaultTokenIcon,
  inputTokenBalance,
  vaultTokenBalance,
  convertedAmount,
  exchangeRateDisplay,
  isConnected,
  isApproved,
  isSupportedChain = true,
  onDeposit,
  onApprove,
  onAmountChange,
  onTokenSelect,
  vaultType,
  disclaimer,
  checkInputConstraints,
  enableTokenSelection = true,
}: DepositProps) => {
  return (
    <div className="w-full px-1 sm:px-3">
      <KernelVaultInput
        type="deposit"
        inputTokenSymbol={inputTokenSymbol}
        inputTokenBalance={inputTokenBalance}
        inputTokenIcon={inputTokenIcon}
        outputTokenSymbol={vaultTokenSymbol}
        outputTokenBalance={vaultTokenBalance}
        outputTokenIcon={vaultTokenIcon}
        convertedAmount={convertedAmount}
        exchangeRateDisplay={exchangeRateDisplay}
        isConnected={isConnected}
        isApproved={isApproved}
        isSupportedChain={isSupportedChain}
        onTokenSelect={onTokenSelect}
        onAmountChange={onAmountChange}
        onApprove={onApprove}
        onDeposit={onDeposit}
        checkInputConstraints={checkInputConstraints}
        disclaimer={disclaimer}
        enableTokenSelection={enableTokenSelection}
        vaultType={vaultType}
      />
    </div>
  );
};

export default Deposit;
